/* global G */
import { curry } from '@gaia/util'

/**
 * model reference getter
 */
// eslint-disable-next-line no-unused-vars
export default curry((module, _) => () => module[G.MODEL][G.STATE][G.REF])
